import { createContext, useContext, useState } from "react";

export type ModalType =
  | "hire-talent"
  | "managed-service"
  | "corporate-training"
  | "individual-training"
  | "start-project"
  | "become-partner"
  | "get-in-touch"
  | null;

export interface ModalPayload {
  programme?: string;
}

interface ModalContextValue {
  activeModal: ModalType;
  modalPayload: ModalPayload | null;
  openModal: (type: ModalType, payload?: ModalPayload) => void;
  closeModal: () => void;
}

const ModalContext = createContext<ModalContextValue>({
  activeModal: null,
  modalPayload: null,
  openModal: () => {},
  closeModal: () => {},
});

export const ModalProvider = ({ children }: { children: React.ReactNode }) => {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const [modalPayload, setModalPayload] = useState<ModalPayload | null>(null);

  const openModal = (type: ModalType, payload?: ModalPayload) => {
    setActiveModal(type);
    setModalPayload(payload ?? null);
  };
  const closeModal = () => {
    setActiveModal(null);
    setModalPayload(null);
  };

  return (
    <ModalContext.Provider value={{ activeModal, modalPayload, openModal, closeModal }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
